/**
 * print web page
 * @see https://stackoverflow.com/questions/21285902/printing-a-part-of-webpage-with-javascript
 */
export default function printPage(wd?: Window) {
  const printWindow = wd || window;
  try {
    // works almost in every browser, but not for firefox
    const print = printWindow.document.execCommand("print", false, undefined);
    if (!print) {
      throw new Error("unsupported");
    }
  } catch {
    printWindow.print();
  }
}
